<ion-app>

  <!--<app-header></app-header>-->

<ion-split-pane contentId="main-content">

    <ion-menu contentId="main-content" [type]="menuType">
      <ion-content>
        <h1 class="ion-padding">Welcome{{ username }}!</h1>
        <ion-item class="logout-item" [routerLink]="'/login'" lines="none" detail="false" (click)="LogoutCentral()">
          <ion-icon slot="start" [ios]="'log-out-outline'" [md]="'log-out-sharp'"></ion-icon>
          <ion-label class="logout-label">Logout</ion-label>
        </ion-item>
        <ion-list>
          <div *ngFor="let p of dynamicMenu | async">
            <ng-container *ngIf="p.is_visible">
              <ion-item [routerLink]="p.url" lines="none" detail="false" routerLinkActive="selected" (click)="navigateAndClose(p.url)">
                <ion-icon slot="start" [ios]="p.icon + '-outline'" [md]="p.icon + '-sharp'"></ion-icon>
                <ion-label><b>{{ p.title }}</b></ion-label>
              </ion-item>
              <ion-list lines="none" class="ion-margin-start">
                <ion-item [routerLink]="c.url" lines="none" detail="false" routerLinkActive="selected"
                          *ngFor="let c of p.children" (click)="navigateAndClose(c.url)">
                  <ion-icon slot="start" [ios]="c.icon + '-outline'" [md]="c.icon + '-sharp'"></ion-icon>
                  <ion-label >{{ c.title }}</ion-label>
                </ion-item>
              </ion-list>
            </ng-container>
          </div>
        </ion-list>

      </ion-content>
      <ion-footer>

        <ion-menu-toggle auto-hide="false">
          <ion-item (click)="logoutTenant()" [routerLink]="'/launch'" lines="none" detail="false" routerLinkActive="selected">
            <ion-icon slot="start" [ios]="'settings-outline'" [md]="'settings-sharp'"></ion-icon>
            <ion-label>Tenant Settings</ion-label>
          </ion-item>
        </ion-menu-toggle>
      </ion-footer>
    </ion-menu>

    <ion-content (click)="onMainContentClick($event)">
      <ion-router-outlet id="main-content"></ion-router-outlet>
    </ion-content>

</ion-split-pane>
</ion-app>
